import { ConfigureDrawerHeader } from '../ConfigureDrawer.styles';
import { RightDrawerHeaderSwitcher } from '../../../Components/RightDrawer/RightDrawerHeaderSwitcher';

export const ConfigureWorkflowDrawerHeader = () => {
  return (
    <ConfigureDrawerHeader isChat>
      <RightDrawerHeaderSwitcher isWorkflow />
    </ConfigureDrawerHeader>
  );
};
